import { FlexBox, Radio } from '@dixa/lib-shared-habla';

import styles from '../../../ArticleRow/ArticleRow.module.scss';

type ArticleRadioInputProps = {
  isSelected: boolean;
};

export function ArticleRadioInput({
  isSelected,
}: ArticleRadioInputProps): JSX.Element {
  return (
    <FlexBox
      alignItems="center"
      justifyContent="center"
      className={styles.articleRadioInputWrapper}
    >
      <Radio
        name="article"
        id="article"
        checked={isSelected}
        onClick={(e) => e.stopPropagation()}
      />
    </FlexBox>
  );
}
